var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCornersOut = function SvgIconCornersOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.75 3.5a1 1 0 1 0 0 2h2.75v2.75a1 1 0 1 0 2 0V4.5a1 1 0 0 0-1-1zM5.5 15.75a1 1 0 1 0-2 0v3.75a1 1 0 0 0 1 1h3.75a1 1 0 1 0 0-2H5.5zM19.5 14.75a1 1 0 0 1 1 1v3.75a1 1 0 0 1-1 1h-3.75a1 1 0 1 1 0-2h2.75v-2.75a1 1 0 0 1 1-1M4.5 3.5a1 1 0 0 0-1 1v3.75a1 1 0 0 0 2 0V5.5h2.75a1 1 0 0 0 0-2z"
  }))));
};
export default SvgIconCornersOut;